<div class="header">
  <div class="logo" (click)="toggleMenu()"  [ngClass]="{'icon-open': menuOpened}" role="button">
    <mat-icon>menu</mat-icon>

    <div class="icon">SOLNATIVO</div>
  </div>

  <div class="logout" (click)="authService.logout()" role="button">
    <mat-icon>power_settings_new</mat-icon>

    <div class="name"> {{authService.nickname || 'admin'}} </div>
  </div>
</div>
